// Version du site - Mis à jour automatiquement à chaque déploiement
// Format: MAJOR.MINOR.PATCH

export const APP_VERSION = "2.1.0";
export const BUILD_DATE = "2026-01-18";
export const BUILD_TIME = "09:00";

// Changelog des versions
export const CHANGELOG = [
  {
    version: "2.1.0",
    date: "2026-01-18",
    changes: [
      "Système de stockage persistant des images (MongoDB)",
      "Correction des URLs d'images entre environnements",
      "Boutons de maintenance dans la Médiathèque",
      "Affichage de la version du site"
    ]
  },
  {
    version: "2.0.0",
    date: "2026-01-17",
    changes: [
      "Header unifié sur toutes les pages",
      "Favicon animé avec faisceau lumineux",
      "Textes modifiables depuis le CMS (badge hero, footer)"
    ]
  },
  {
    version: "1.0.0",
    date: "2026-01-06",
    changes: [
      "Version initiale du site MSC"
    ]
  }
];

export default {
  version: APP_VERSION,
  buildDate: BUILD_DATE,
  buildTime: BUILD_TIME,
  changelog: CHANGELOG
};
